import { useState } from 'react';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';

import Image from 'global/Image';
import SwitchContent from 'features/multi-porto/components/SwitchContent';

import useBroadcastChannel, {
  BroadcastMessage,
} from 'hooks/useBroadcastChannel';
import useSubAccounts from 'features/multi-porto/hooks/useSubAccounts';

import { SwitchButton, MenuText } from './popover.styled';

interface SwitchPortfolioProps {
  placement: TooltipPlacement;
  hideTransfer?: boolean;
  width?: number;
  radius?: number;
  source?: string;
  onClick?: () => void;
}

export default function SwitchPortfolio({
  placement,
  hideTransfer = false,
  width = 0,
  radius = 4,
  source = '',
  onClick = () => {},
}: Readonly<SwitchPortfolioProps>) {
  const [visible, setVisible] = useState<boolean>(false);

  const { postMessage } =
    useBroadcastChannel<BroadcastMessage>('multi-portfolio');

  const { subAccounts, activeAccountName } = useSubAccounts();

  const handleClickMenu = () => {
    setVisible(false);
  };

  if (subAccounts.length <= 1) return null;

  return (
    <Popover
      destroyTooltipOnHide
      visible={visible}
      onVisibleChange={() => setVisible(!visible)}
      motion={{ motionName: 'fade' }}
      content={
        <SwitchContent
          hideTransfer={hideTransfer}
          onClick={handleClickMenu}
          onClose={onClick}
          onSuccessSwitch={(acountNumber) => {
            postMessage({
              type: 'refetch-portfolio',
              message: acountNumber,
            });
          }}
          width={width}
          source={source}
        />
      }
      trigger="click"
      placement={placement}
      getPopupContainer={(trigger) => trigger.parentElement}
      zIndex={10}
    >
      <SwitchButton radius={radius}>
        <Image
          src="/icon/multi-porto/portfolio.svg"
          alt=""
          width={16}
          height={16}
        />
        <MenuText>
          <span>{activeAccountName || 'Switch Portfolio'}</span>
        </MenuText>
        <Image
          src="/icon/chevron/down-primary.svg"
          alt=""
          className={visible ? 'open' : ''}
          width={16}
          height={16}
        />
      </SwitchButton>
    </Popover>
  );
}
